import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative overflow-hidden rounded-[28px] bg-cobalt p-7 text-daylight before:absolute before:right-8 before:top-8 before:size-24 before:rounded-full before:border before:border-daylight/35 md:p-12 lg:p-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </DaylightSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
